import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'Payment';

const PaymentApi: any = baseApi(endpoint);

export default PaymentApi;